"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.lazyMultiInject = exports.lazyInjectTagged = exports.lazyInjectNamed = exports.lazyInject = exports.container = exports.bindToContainer = exports.setDIDecorators = void 0;
require("reflect-metadata");
require("es6-map");
var inversify_1 = require("inversify");
var inversify_inject_decorators_1 = __importDefault(require("inversify-inject-decorators"));
var ObservableService_1 = require("./services/ObservableService");
var StorageService_1 = require("./services/StorageService");
var types_1 = require("./types");
var ClickEventService_1 = require("./services/ClickEventService");
var InputEventService_1 = require("./services/InputEventService");
var UnloadEventService_1 = require("./services/UnloadEventService");
var VisibilityEventService_1 = require("./services/VisibilityEventService");
var PipelineService_1 = require("./services/PipelineService");
var IntersectionService_1 = require("./services/IntersectionService");
var RouteStackService_1 = require("./services/RouteStackService");
var ApplicationExecutor_1 = require("./services/ApplicationExecutor");
var LocalStoreService_1 = require("./services/LocalStoreService");
var SessionStoreService_1 = require("./services/SessionStoreService");
var SessionService_1 = require("./services/SessionService");
var TransformFieldsService_1 = require("./services/TransformFieldsService");
var AdjustTimeService_1 = require("./services/AdjustTimeService");
var ActiveTabService_1 = require("./services/ActiveTabService");
var VisibilityEventObserver_1 = require("./services/VisibilityEventObserver");
var LeaveOpsService_1 = require("./services/LeaveOpsService");
var PasteEventService_1 = require("./services/PasteEventService");
var ExposeService_1 = require("./services/ExposeService");
var ExposeDataManager_1 = require("./services/ExposeDataManager");
var container = new inversify_1.Container();
exports.container = container;
var bind = function (c) {
    c.bind(types_1.TYPES.IObservableService).to(ObservableService_1.ObservableService).inSingletonScope();
    c.bind(types_1.TYPES.IApplicationExecutor)
        .to(ApplicationExecutor_1.ApplicationExecutor)
        .inSingletonScope();
    c.bind(types_1.TYPES.IStorageService).to(StorageService_1.StorageService);
    c.bind(types_1.TYPES.IEventObservable)
        .to(ClickEventService_1.ClickEventService)
        .inSingletonScope()
        .whenTargetNamed(types_1.TAG.ClickEventService);
    c.bind(types_1.TYPES.IEventObservable)
        .to(InputEventService_1.InputEventService)
        .inSingletonScope()
        .whenTargetNamed(types_1.TAG.InputEventService);
    c.bind(types_1.TYPES.IEventObservable)
        .to(PasteEventService_1.PasteEventService)
        .inSingletonScope()
        .whenTargetNamed(types_1.TAG.PasteEventService);
    c.bind(types_1.TYPES.IEventObservable)
        .to(UnloadEventService_1.UnloadEventService)
        .inSingletonScope()
        .whenTargetNamed(types_1.TAG.UnloadEventService);
    c.bind(types_1.TYPES.IEventObservable)
        .to(VisibilityEventService_1.VisibilityEventService)
        .inSingletonScope()
        .whenTargetNamed(types_1.TAG.VisibilityEventService);
    c.bind(types_1.TYPES.IPipelineService).to(PipelineService_1.PipelineService);
    c.bind(types_1.TYPES.IIntersectionService).to(IntersectionService_1.IntersectionService);
    c.bind(types_1.TYPES.IRouteStackService).to(RouteStackService_1.RouteStackService).inSingletonScope();
    c.bind(types_1.TYPES.IStoreService)
        .to(LocalStoreService_1.LocalStoreService)
        .inSingletonScope()
        .whenTargetNamed(types_1.TAG.LocalStoreService);
    c.bind(types_1.TYPES.IStoreService)
        .to(SessionStoreService_1.SessionStoreService)
        .inSingletonScope()
        .whenTargetNamed(types_1.TAG.SessionStoreService);
    c.bind(types_1.TYPES.ISessionService).to(SessionService_1.SessionService).inSingletonScope();
    c.bind(types_1.TYPES.ITransformFieldsService).to(TransformFieldsService_1.TransformFieldsService);
    c.bind(types_1.TYPES.IAdjustTimeService).to(AdjustTimeService_1.AdjustTimeService).inSingletonScope();
    c.bind(types_1.TYPES.IActiveTabService).to(ActiveTabService_1.ActiveTabService).inSingletonScope();
    c.bind(types_1.TYPES.IObserver)
        .to(VisibilityEventObserver_1.VisibilityEventObserver)
        .inSingletonScope()
        .whenTargetNamed(types_1.TAG.VisibilityEventObserver);
    c.bind(types_1.TYPES.ILeaveOpsService).to(LeaveOpsService_1.LeaveOpsService);
    c.bind(types_1.TYPES.IExposeService).to(ExposeService_1.ExposeService).inSingletonScope();
    c.bind(types_1.TYPES.IExposeDataManager)
        .to(ExposeDataManager_1.ExposeDataManager)
        .inSingletonScope();
};
var lazyInject;
exports.lazyInject = lazyInject;
var lazyInjectNamed;
exports.lazyInjectNamed = lazyInjectNamed;
var lazyInjectTagged;
exports.lazyInjectTagged = lazyInjectTagged;
var lazyMultiInject;
exports.lazyMultiInject = lazyMultiInject;
var setDIDecorators = function (c) {
    var _a = (0, inversify_inject_decorators_1.default)(c, false), newLazyInject = _a.lazyInject, newLazyInjectNamed = _a.lazyInjectNamed, newLazyInjectTagged = _a.lazyInjectTagged, newLazyMultiInject = _a.lazyMultiInject;
    exports.lazyInject = lazyInject = newLazyInject;
    exports.lazyInjectNamed = lazyInjectNamed = newLazyInjectNamed;
    exports.lazyInjectTagged = lazyInjectTagged = newLazyInjectTagged;
    exports.lazyMultiInject = lazyMultiInject = newLazyMultiInject;
};
exports.setDIDecorators = setDIDecorators;
bind(container);
(0, exports.setDIDecorators)(container);
var bindToContainer = function (newContainer) {
    bind(newContainer);
    (0, exports.setDIDecorators)(newContainer);
};
exports.bindToContainer = bindToContainer;
